import { MarketplaceLoadablePage } from 'utils/loadable/MarketplaceLoadablePage'

export const ShipperRateMatcherIndexAsync = MarketplaceLoadablePage(() =>
  import(/* webpackChunkName: "shipper-rate-matcher" */ './index')
)

export default ShipperRateMatcherIndexAsync
